/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Contact_Default_PrefixInputs */

const en_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's`)
};

const ar_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لنبدأ`)
};

const bn_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চলুন`)
};

const de_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass uns`)
};

const es_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos a`)
};

const fr_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construisons`)
};

const pt_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos`)
};

const zh_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让我们`)
};

const tr_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haydi`)
};

const ru_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Давайте`)
};

const pl_heading_contact_default_prefix = /** @type {(inputs: Heading_Contact_Default_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zróbmy to`)
};

/**
* | output |
* | --- |
* | "Let's" |
*
* @param {Heading_Contact_Default_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_contact_default_prefix = /** @type {((inputs?: Heading_Contact_Default_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Contact_Default_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_contact_default_prefix(inputs)
	if (locale === "bn") return bn_heading_contact_default_prefix(inputs)
	if (locale === "de") return de_heading_contact_default_prefix(inputs)
	if (locale === "es") return es_heading_contact_default_prefix(inputs)
	if (locale === "fr") return fr_heading_contact_default_prefix(inputs)
	if (locale === "pt") return pt_heading_contact_default_prefix(inputs)
	if (locale === "zh") return zh_heading_contact_default_prefix(inputs)
	if (locale === "tr") return tr_heading_contact_default_prefix(inputs)
	if (locale === "ru") return ru_heading_contact_default_prefix(inputs)
	if (locale === "pl") return pl_heading_contact_default_prefix(inputs)
	return en_heading_contact_default_prefix(inputs)
});